module.exports = __webpack_public_path__ + "img/full4-min.07d734c6.png";